import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { buildStandardsRulesetSynthesisFormData } from "./buildStandardsRulesetSynthesisFormData";
import { generativeAiAppGroupIdStandardsRulesetSynthesis } from "./constants";
import type { PostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisProps } from "./types";
import { isPostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisResult } from "./validators";

/**
 * POSTWS handler for the "/:app_group_id/generative_ai/standards_ruleset_synthesis" endpoint
 */
export const postwsGenerativeAiAppGroupIdStandardsRulesetSynthesis = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdStandardsRulesetSynthesis,
  async (
    signal,
    {
      appGroupId,
      interactionSite,
      existingRulesets,
      files,
      modelChoice,
      jobToken,
    }: PostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisProps
  ): Promise<{}> => {
    const body = buildStandardsRulesetSynthesisFormData({
      interactionSite,
      existingRulesets,
      files,
      modelChoice,
      jobToken,
    });

    return await fetch(
      `/${appGroupId}/generative_ai/standards_ruleset_synthesis`,
      "POST",
      {},
      { signal, body },
      // setContentType: false lets the browser set the multipart boundary.
      { setContentType: false, propagateFetchRequestError: false }
    );
  },
  isPostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisResult
);
